import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/headache-watch/dashboard")({
    component: () => <div>Hello /_app/headache-watch/patients!</div>,
});
